import {Component} from '@angular/core';
import {BaseFieldType} from '../base-field-type';
import {ReactiveFormsModule} from "@angular/forms";
import {NgIf} from "@angular/common";
import {FormlyModule} from "@ngx-formly/core";
import {NbInputModule} from "@nebular/theme";

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgIf,
    FormlyModule,
    NbInputModule
  ],
  templateUrl: './input-filter-property.component.html'
})
export class InputFilterPropertyComponent extends BaseFieldType {
}
